const footerLinks1 = [
  {
    href: "https://secure.givelively.org/donate/conservation-x-labs-inc/wild-me",
    id: "FOOTER_DONATE",
  },
  {
    href: "https://wildbook.docs.wildme.org/getting-started-with-wildbook.html",
    id: "FOOTER_DOCUMENTATION",
  },
];
const footerLinks2 = [
  { href: "https://community.wildme.org", id: "FOOTER_COMMUNITY_FORUM" },
  { href: "https://github.com/WildMeOrg", id: "FOOTER_GITHUB" },
];
const footerLinks3 = [
  {
    href: "https://www.instagram.com/conservationxlabs",
    id: "FOOTER_INSTAGRAM",
  },
  { href: "https://www.facebook.com/ConservationXLabs", id: "FOOTER_FACEBOOK" },
  { href: "https://twitter.com/conservationx", id: "FOOTER_TWITTER" },
  {
    href: "https://www.linkedin.com/company/conservationxlabs/",
    id: "FOOTER_LINKEDIN",
  },
];

export { footerLinks1, footerLinks2, footerLinks3 };
